module.exports = __webpack_public_path__ + "img/step3_pay.fd655cef.png";